import {setCookie} from '../libs/setCookie';
import {getCookie} from '../libs/getCookie';
import {EXTRA_URL_COOKIE_KEY} from '../constants';

const LIST_OF_UTM_MARKS = [
    'utm_source',
    'utm_medium',
    'utm_content',
    'utm_campaign',
    'utm_term',
    'referral',
    'keyword',
];
/**
 * Collects UTM parameters from URL and stores them in the extraUrlData cookie
 */
export const collectUtmParams = () => {
    try {
        if (typeof window === 'undefined') return;
        const urlParams = new URLSearchParams(window.location.search);
        const utmParams: Record<string, string> = {};
        LIST_OF_UTM_MARKS.map(mark => {
            if (urlParams.get(mark)) {
                utmParams[mark] = urlParams.get(mark);
            }
        });

        // Filter out undefined values
        const filteredParams = Object.fromEntries(
            Object.entries(utmParams).filter(([_, value]) => value !== undefined),
        );

        // If no UTM parameters found, return
        if (Object.keys(filteredParams).length === 0) {
            return;
        }

        const existingCookie = getCookie(EXTRA_URL_COOKIE_KEY);
        let cookieData = {};
        if (existingCookie) {
            try {
                cookieData = JSON.parse(decodeURIComponent(existingCookie));
            } catch (error) {
                console.error('Error parsing extraUrlData cookie:', error);
            }
        }

        const updatedCookieData = {
            ...cookieData,
            ...filteredParams,
        };

        setCookie(EXTRA_URL_COOKIE_KEY, encodeURIComponent(JSON.stringify(updatedCookieData)), 365);
    } catch (error) {
        console.error('Error collecting UTM parameters:', error);
    }
};
